import { lazy } from 'react';
import { Route, Routes } from 'react-router';

import TenantAdministrationLayout from '../layouts/tenant-administration-layout';

const TenantManagementScreen = lazy(
  () => import('../screens/Platform/tenant-management/tenant-management.screen')
);

const TenantDetailsScreen = lazy(
  () => import('../screens/Platform/tenant-management/tenant-details.screen')
);

/**
 * Platform administration is a control-plane-only application surface. Do not mount UserProvider or
 * any tenant-data provider here: those bootstrap `/user/me`, roles, permissions and metadata from a
 * customer database, while the platform host deliberately has no tenant DataSource.
 */
const PlatformRoutes = () => (
  <Routes>
    <Route element={<TenantAdministrationLayout />}>
      <Route element={<TenantManagementScreen />}>
        <Route index element={null} />
        <Route path="provision" element={null} />
      </Route>
      <Route path=":tenantUuid" element={<TenantDetailsScreen />} />
    </Route>
  </Routes>
);

export default PlatformRoutes;
